<li>
  <a *ngIf="route" routerLinkActive="active" [routerLink]="route"
     style="cursor: pointer; display: block; text-decoration: none;" id="{{ name }}" (click)="showSub = !showSub">
        <span style="display: block;">
            <i class="fa fa-fw fa-lg" [ngClass]="icon"></i> {{ name }}
        </span>
    <i
       class="fa fa-fw pull-right fa-chevron-down"
       *ngIf="subItems !== undefined"
       routerLinkActive="fa-chevron-up-override"
       [ngClass]="showSub ? 'fa-chevron-up-override' : 'fa-chevron-down'"
       style="margin-top:-16px; cursor: pointer;"></i>
  </a>
  <a *ngIf="!route" routerLinkActive="active" (click)="showSub = !showSub"
     style="cursor: pointer; display: block; text-decoration: none;" id="{{ name }}">
        <span style="display: block;">
            <i class="fa fa-fw fa-lg" [ngClass]="icon"></i> {{ name }}
        </span>
    <i
       class="fa fa-fw pull-right fa-chevron-down"
       *ngIf="subItems !== undefined"
       routerLinkActive="fa-chevron-up-override"
       [ngClass]="subItemsActive() || showSub ? 'fa-chevron-up-override' : 'fa-chevron-down'"
       style="margin-top:-16px; cursor: pointer;"></i>
  </a>
  <ul class="nav nav-second-level" *ngIf="showSub">
    <li *ngFor="let subItem of subItems" style="width: 100%;">
      <a class="sub-menu"
         [routerLink]="subItem.route" [queryParams]="subItem.params" [fragment]="subItem.fragment"
         [ngClass]="router.url.endsWith(subItem.route) && containsParams(subItem) ? 'active' : ''">
          {{ subItem.name }}
      </a>
    </li>
  </ul>
</li>
